<template>
  <div>
    <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" noAbout="noAbout"></topIcon>
    <van-loading type="spinner" v-if="nodata"/>
    <div>
      <div class="logo" :class="[`${dominItem.templateId}`, `${dominItem.templateId}1`]">
        {{ dominItem.logoName || 'Logo' }}
      </div>
      <div class="category" :class="`${dominItem.templateId}`">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
      </div>
    </div>
    <div style="padding: 0 10%;">
      <div class="news-page">
        <div class="container">
          <div class="left-column">
            <section class="news-category">
              <div class="gallery-header">
                <span style="font-size: 22px; padding-left: 10px; font-weight: bold;">{{ $t('con_recommended') }}</span>
              </div>
              <article class="news-item" v-for="item in articleList" @click="toDetail(item.articleShortName)">
                <h3 class="news-title twoHde">{{ item.articleTitle }}</h3>
                <p class="news-desc threeHde">
                  {{ item.articleIntro }}
                </p>
              </article>
            </section>
          </div>

          <div class="right-column">
            <article class="featured-news" @click="toDetail(bestItem.articleShortName)">
              <img
                  :src="bestItem.articleImage"
                  class="featured-image"
              />
              <h2 class="featured-title twoHde">{{ bestItem.articleTitle }}</h2>
              <p class="featured-desc threeHde">
                {{ bestItem.articleIntro }}
              </p>
            </article>

            <div class="news-row">
              <article class="news-item-small"  v-for="item in articleList1" @click="toDetail(item.articleShortName)">
                <img
                    :src="item.articleImage"
                    class="small-image"
                />
                <h3 class="small-title twoHde">{{ item.articleTitle }}</h3>
                <p class="small-desc threeHde">
                  {{ item.articleIntro }}
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <div class="but-box">
        <div class="image-gallery">
          <div class="gallery-header">
            <span style="font-size: 22px; padding-left: 10px; font-weight: bold;">{{ $t('con_latest') }}</span>
          </div>
          <div class="gallery-grid">
            <div v-for="item in articleList4" :key="item.id" class="gallery-item" @click="toDetail(item.articleShortName)">
              <div class="gallery-image-wrapper">
                <img :src="item.articleImage"  class="gallery-image" />
              </div>
              <div class="gallery-content">
                <div class="gallery-category"></div>
                <h3 class="gallery-title twoHde">{{ item.articleTitle }}</h3>
                <p class="gallery-desc threeHde">{{ item.articleSummary }}</p>
<!--                <div class="gallery-meta">-->
<!--                  <span class="gallery-date">{{ item.uploadTime }}</span>-->
<!--                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttom">
      <div class="explore">
        <span style="color: #222222">{{ $t('con_Explore') }}</span>
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
        <div class="logo" style="color: #222222;">{{ dominItem.logoName || 'Logo' }}</div>
      <footers is00="is00" :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getContentList, getLatestNews, getRecommend, getOne, getDomainName, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList:[],
      latestNewsList:[],
      articleList:[],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast:[],
      recommendList1: [],
      typeList: [{label: this.$t('con_home'), id: 1},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_about'), id: 8},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    }else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }

      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        // this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({articleCategoryId: this.current,pageNum: this.newsPageNum, pageSize: 10, articleNationId: this.nationId, articleType: 'con_recommended'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows

        // this.articleList.map(r => {
        //   // r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
        // })
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({articleCategoryId: this.current, pageNum: this.newsPageNum, pageSize: 8, articleNationId: this.nationId,  articleType: 'con_latest'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 5,

        articleNationId: this.nationId, articleType: 'con_hot_con'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
          this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({articleCategoryId: this.current, pageNum: 1, pageSize: 2, articleNationId: this.nationId, articleType: 'con_bestnew'}).then(res => {
        res.rows.map(r=>{
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({articleCategoryId: this.current, pageNum: 1, pageSize: 9, articleNationId: this.nationId, articleType: 'con_bestnew'}).then(res => {
        res.rows.map(r=>{
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({articleCategoryId: this.current,pageNum: 3, pageSize: 6, articleNationId: this.nationId,  articleType: 'con_related'}).then(res => {
        res.rows.map(r=>{
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  //max-width: 1200px;
  margin: 0 auto;
  padding: 20px;



  .container {
    display: flex;
    gap: 20px;
  }

  .left-column {
    flex: 0.5;
  }

  .right-column {
    flex: 1.5;
  }

  .category-title {
    font-size: 1.2rem;
    margin-bottom: 10px;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 5px;
  }

  .news-item {
    margin-top: 10px;
    margin-bottom: 20px;
    border-bottom: 1px solid #666666;
    padding-bottom: 20px;
  }

  .news-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  .news-desc {
    font-size: 15px;
    line-height: 1.4;
    margin-bottom: 5px;
  }

  .news-points {
    list-style: disc;
    margin-left: 20px;
    font-size: 0.9rem;
  }

  .featured-news {
    margin-bottom: 20px;
  }

  .featured-image {
    width: 100%;
    height: 400px;
    object-fit: cover;
    margin-bottom: 10px;
  }

  .featured-title {
    font-size: 25px;
    margin-bottom: 10px;
  }

  .featured-desc {
    font-size: 15px;
    line-height: 1.4;
    margin-bottom: 5px;
  }

  .featured-points {
    list-style: disc;
    margin-left: 20px;
    font-size: 0.9rem;
  }

  .news-row {
    flex-wrap: wrap;
    display: flex;
    gap: 20px;
  }

  .news-item-small {
    width: 45%;
  }

  .small-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
    margin-bottom: 8px;
  }

  .small-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
  }

  .small-desc {
    font-size: 13px;
    line-height: 1.4;
  }
}

.but-box {
    margin: 40px 0;

  .image-gallery {
    margin: 20px 0;
  }

  .gallery-header {
    margin-bottom: 30px;
    padding-bottom: 10px;
    border-bottom: 2px solid #000;
  }

  .gallery-header h2 {
    font-size: 28px;
    font-weight: bold;
    color: #000;
    margin: 0;
  }

  .gallery-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .gallery-item {
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .gallery-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
  }

  .gallery-image-wrapper {
    width: 100%;
    height: 200px;
    overflow: hidden;
    position: relative;
  }

  .gallery-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .gallery-item:hover .gallery-image {
    transform: scale(1.05);
  }

  .gallery-content {
    padding: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .gallery-category {
    font-size: 12px;
    color: #FC625C;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 10px;
  }

  .gallery-title {
    font-size: 18px;
    font-weight: bold;
    color: #000;
    margin: 0 0 10px 0;
    line-height: 1.3;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .gallery-desc {
    font-size: 14px;
    color: #666;
    line-height: 1.5;
    margin: 0 0 15px 0;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .gallery-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #999;
  }

  .gallery-author {
    font-weight: 500;
  }

  .gallery-date {
    font-style: italic;
  }
}


.logo {
  width: 100%;
  padding: 20px 20px 10px 10%;
  display: flex;
  box-sizing: border-box;
  font-size: 40px;
  color:#000000;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  width: 100%;
  padding: 10px 10%;
  min-height: 40px;
  margin-bottom: 30px;
  color: #555555;
  border-top: 2px solid #CCCCCC;
  border-bottom: 2px solid #CCCCCC;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid var(--themeColor);
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
  }

  span:hover {
    color: #000000;
    background: #EEEEEE;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    color:#000000;;
  }
}

.buttom {
  background: #F4F4F4;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin:  auto;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;

    span:first-child {
      color: #004F8B;
      font-size: 18px;
      font-weight: bold;
      margin-right: 30px;
    }

    span {
      margin-right: 10px;
      font-size: 15px;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  padding: 0 10% 20px;
  display: flex;
  flex-wrap: wrap;
  span{
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5){
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(6){
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

</style>
